import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../services/form-field-control.service';
import { FormField } from '../../../shared/form-field/form-field';

@Component({
  standalone: false,
  selector: 'claim-adjudication-modal',
  templateUrl: 'claim-adjudication-modal.template.html',
  styleUrls: ['claim-adjudication-modal.scss'],
  providers: [FormFieldControlService],
})
export class ClaimAdjudicationModalComponent implements OnInit {
  @Input() formFields: FormField<string>[] = [];
  form: FormGroup;
  payLoad = '';

  constructor(private qcs: FormFieldControlService) {}

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
  }

  onSubmit() {
    // TODO: on submit
  }
}
